export default __webpack_public_path__ + "static/media/Real Estate.554662df.webp";